import { useEffect } from 'react';
import { useChatSidebarStore } from '@ui/features/mildang-ai/stores/chatStore';
import notification from '@shared/utils/notification';
import { confirm } from '@mildang/design-system-legacy/esm/components/molecules/dialog/ConfirmDialog';
import { t } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import { getRegisterFcmTokenInput } from '@ui/features/mildang-ai/mutations/registerFcmToken/useRegisterFcmToken';
import { RegisterFcmTokenDocument, RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables } from '@ui/features/mildang-ai/mutations/registerFcmToken';
import { isIOSEnv } from '@shared/utils/notification/IOSNotification';
import { PushNotificationContent } from '@ui/features/mildang-ai/ui/ChatChannelList/NotificationIconButton';
import { isLikelyTWA } from '@shared/utils/notification/WebPushNotification';
import { useMutation } from '@apollo/client';


export const useConfirmNotificationPermission = () => {
  const { i18n } = useLingui();

  const { isSidebarOpen } = useChatSidebarStore();

  const [registerFcmToken] = useMutation<RegisterFcmTokenMutation, RegisterFcmTokenMutationVariables>(RegisterFcmTokenDocument);
  useEffect(() => {
    const handler = async () => {
      try {
        if (!isSidebarOpen) {
          return;
        }

        if (!notification.supportsNotifications()) {
          return;
        }

        const permissionState = await notification.getPermissionState();

        if (permissionState === 'granted') {
          await notification.requestPermission().then(async (permission) => {
            if (permission === 'granted') {
              const input = await getRegisterFcmTokenInput();
              if (!input) {
                return;
              }
              registerFcmToken({
                variables: {
                  input,
                },
              });
            }
          });

          return;
        }

        if (permissionState === 'default') {
          await confirm({
            title: <span>{t(i18n)`채팅 푸시 알림 설정 바로가기`}</span>,
            desc: <PushNotificationContent type="default" />,
            confirmText: <span>{t(i18n)`알림 설정 바로가기`}</span>,
            confirmButtonProps: {
              color: 'primary',
            },
          });

          await notification.requestPermission().then(async (permission) => {
            if (permission === 'granted') {
              const input = await getRegisterFcmTokenInput();
              if (!input) {
                return;
              }
              registerFcmToken({
                variables: {
                  input,
                },
              });
            }
          });
        } else if (permissionState === 'denied' && !isIOSEnv()) {
          await confirm({
            title: <span>{t(i18n)`푸시 알림이 차단되어 있어요`}</span>,
            desc: <PushNotificationContent type={isLikelyTWA() ? 'android-denied' : 'denied'} />,
            confirmText: <span>{t(i18n)`확인`}</span>,
            confirmButtonProps: {
              color: 'primary',
            },
          });
        }
      } catch (error) {}
    };

    handler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSidebarOpen]);
};

export const ConfirmNotificationPermission = () => {
  useConfirmNotificationPermission();
  return null;
};
